export default "__VITE_ASSET__a1a23f2e__"